<template>
  <v-flex>
    <div class="d-flex align-center">
      <h1>{{ name }}</h1>
    </div>
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <v-card v-if="!loading">
      <v-card-title>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          v-model="search"
          class="mr-3"
        ></v-text-field>
        <v-dialog v-model="dialog" persistent max-width="700px">
          <v-btn color="primary" dark slot="activator" style="margin-right: 0">Add New</v-btn>
          <dialog-distributor
            :distributorInit="{}"
            :title="dialogTittle"
            @close="dialog = false"
            @save="addDistributor"
            ref="dialog"
          ></dialog-distributor>
        </v-dialog>
      </v-card-title>
      <v-list two-line>
        <v-list-tile avatar v-if="distributorsPage" v-for="item in distributorsPage" :key="item.name" @click="$router.push(`/distributors/${item.id}?p=${page}`)">
          <v-list-tile-avatar>
            <v-icon class="red lighten-1 white--text">local_mall</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ item.createdAt | moment }}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            {{ item.shortName }}
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card>
    <div class="text-xs-center" v-if="!loading">
      <v-pagination v-if="distributorsTotalPages" :length="distributorsTotalPages" v-model="page"></v-pagination>
    </div>
    <v-snackbar
      :timeout="3000"
      :bottom="true"
      :right="true"
      :multi-line="false"
      v-model="snackBar"
    >
      {{ snackBarText }}
      <v-btn flat color="pink" @click.native="snackBar = false">Close</v-btn>
    </v-snackbar>
  </v-flex>
</template>

<script>
import Codes from '@/components/Codes/Index'
import DialogDistributor from '@/components/Distributors/Dialog'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { DISTRIBS_LIST, DISTRIBS_ADD } from '../../store/actions/distributors'

export default {
  data: () => ({
    search: '',
    name: 'Distributors',
    dialog: false,
    dialogTittle: 'Add Distributor',
    page: 1,
    limit: 20,
    loading: false,
    snackBarText: 'Distributor with same name exist',
    snackBar: false
  }),
  computed: {
    ...mapGetters([
      'distributors'
    ]),
    distributorsList: function () {
      const search = this.search.trim()
      if (search) {
        return this.distributors.filter(item => {
          return item.name.toLowerCase().includes(search.trim().toLowerCase())
        })
      }
      return this.distributors
    },
    distributorsPage: function () {
      const start = (this.page - 1) * this.limit
      const end = start + this.limit
      return this.distributorsList.slice(start, end)
    },
    distributorsTotalPages: function () {
      return Math.ceil(this.distributorsList.length / this.limit)
    }
  },
  methods: {
    addDistributor: async function (distributor) {
      const newItem = await this.$store.dispatch(DISTRIBS_ADD, distributor)
      if (!newItem) {
        this.snackBar = true
      } else {
        this.dialog = false
        this.$refs.dialog.clear()
        this.page = 1
      }
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('MMMM DD YYYY, hh:mm:ss')
    }
  },
  components: {
    DialogDistributor,
    Codes
  },
  mounted: async function () {
    if (this.$route.query.p) {
      this.page = parseInt(this.$route.query.p)
    }
    this.loading = true
    await this.$store.dispatch(DISTRIBS_LIST)
    this.loading = false
  },
  watch: {
    '$route': function (to) {
      if (to.query.p) {
        this.page = parseInt(to.query.p)
      }
    },
    search: function () {
      this.page = 1
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Distributors/Index.vue